module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold.0ae2f9c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Bold.woff2
// module id = iLYe
// module chunks = 0